import axios from 'axios';
import config from '../config';
import { LOGOUT, SET_USER_RT_ACTION } from '../constants';
import { getAccessToken, isValidAccessToken, setAccessToken } from '../utils/tokens';
import { fetchAuth } from '../api/odin-api';
import store from '../store/index';

function errorHandler(error) {
  if (error.response) {
    // Запрос был сделан, и сервер ответил кодом состояния
    // который выходит за пределы диапазона 2xx
    const {
      message,
      response: { status: code },
    } = error;

    switch (code) {
      case 401:
      case 403:
        store.dispatch(LOGOUT);
        break;
      default:
        // eslint-disable-next-line no-console
        console.error(`Error response auth-dashboard/authInterceptors: ${message}`);
        break;
    }
  } else if (error.request) {
    // Запрос был сделан, но ответ не получен
    // `error.request` — это экземпляр XMLHttpRequest в браузере и экземпляр
    // http.ClientRequest в node.js
    // eslint-disable-next-line no-console
    console.error(`Error request auth-dashboard/authInterceptors: ${error.message}`);
  } else {
    // Произошло что-то при настройке запроса, вызвавшее ошибку
    // eslint-disable-next-line no-console
    console.error(`Error settings auth-dashboard/authInterceptors: ${error.message}`);
  }
}

function refreshToken() {
  const token = getAccessToken(config.cookieName);

  const axiosRefreshToken = axios.create({
    baseURL: config.baseURL,
    timeout: 5000,
    headers: {
      Authorization: `Bearer ${token}`,
      'x-auth-app': 'odin',
    },
    withCredentials: true,
  });

  if (token) {
    return axiosRefreshToken.patch('/api/v1/auth/refresh-token');
  }
  return Promise.reject(new Error('auth-dashboard: нет токена'));
}

const setup = (() => {
  fetchAuth.interceptors.request.use(
    async (settings) => {
      const token = getAccessToken(config.cookieName);
      const isSendNow = store.state.isSendRefreshToken;

      if (!isValidAccessToken(config.cookieName) && token && !isSendNow) {
        store.dispatch(SET_USER_RT_ACTION, true);

        try {
          const response = await refreshToken();

          const newAccessToken = response.data.data.access_token;
          setAccessToken(config.cookieName, newAccessToken);
          store.dispatch(SET_USER_RT_ACTION, false);
        } catch (error) {
          errorHandler(error);
          store.dispatch(SET_USER_RT_ACTION, false);
        }
      }

      //   Подробнее об этом костыле в репозитории bh-frontend src/api/README-USERS.MD
      async function delay() {
        await new Promise((resolve) => {
          let timer = 0;
          const interval = setInterval(() => {
            // Проверяем был ли уже отправлен запрос на обновление токена
            const isSendNowActual = store.state.isSendRefreshToken;
            if (!isSendNowActual) {
              clearInterval(interval);
              resolve();
            }

            // Timeout для обновления
            if (timer >= 5) {
              clearInterval(interval);
              resolve();
            }
            timer += 0.5;
          }, 500);
        });
      }

      await delay();

      const accessTokenActual = getAccessToken(config.cookieName);
      if (accessTokenActual) {
        settings.headers.Authorization = `Bearer ${accessTokenActual}`;
      }
      settings.headers['x-auth-app'] = 'odin';

      return settings;
    },

    (error) => {
      errorHandler(error);
      console.warn('error', error);
    },
  );
});

export default setup;



// WEBPACK FOOTER //
// ./src/middleware/authInterceptors.js